import React from "react";
import { PageContainer } from "shared";

export default function index() {
  return <PageContainer>index</PageContainer>;
}
